import styled from "styled-components";
import { Box, Flex } from "rebass/styled-components";

export const StyledPreviewPlayer = styled(Box)`
  border-radius: 8px;
  container-name: video-player;
  container-type: inline-size;
  overflow: hidden;
  position: relative;
  width: 100%;

  &[data-fullscreen="true"] {
    border-radius: 0;
  }

  .vjs-play-progress,
  .vjs-slider-bar {
    background: ${({ theme }) => theme.colors.envy};
  }

  .video-js:hover .vjs-big-play-button {
    background-color: unset;
  }

  .vjs-big-play-button {
    background: unset;
    border: unset;
    border-radius: 50%;
    height: 5rem;
    margin: 0;
    opacity: 0.8;
    position: absolute;
    transform: translateX(-50%) translateY(-50%);
    transition: opacity 0.15s;
    width: 5rem;

    :focus {
      border-color: rgb(12, 19, 24, 0.9);
    }

    > .vjs-icon-placeholder {
      --width: 40%;

      background-image: url('data:image/svg+xml;utf8,<svg stroke="currentColor" fill="white" stroke-width="0" viewBox="0 0 448 512" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path></svg>');
      background-repeat: no-repeat;
      display: block;
      height: var(--width);
      left: 55%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: var(--width);

      :before {
        content: "";
      }
    }

    > .vjs-control-text {
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }
  }
`;

export const SourceLoadingOverlay = styled(Flex)<{
  $isFullscreen?: boolean;
}>`
  align-items: center;
  backdrop-filter: blur(4px);
  background: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  flex-direction: column;
  gap: 8px;
  padding: 16px 20px;
  position: absolute;
  z-index: 5;

  ${({ $isFullscreen }) =>
    $isFullscreen
      ? `
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
  `
      : `
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `}
`;

export const SourceLoadingText = styled(Box)`
  color: rgba(255, 255, 255, 0.85);
  font-family: "Barlow", sans-serif;
  font-size: 14px;
  font-weight: 500;
`;

export const PreloadVideo = styled.video<{ $visible: boolean }>`
  height: 100%;
  left: 0;
  object-fit: contain;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 4;
`;
